import { eventListenerOptions } from '@spinnwerk/polyfills';

/**
 * Should not be called directly.
 * @see {@link fileInput}
 *
 * @param {NodeList} elements
 * @param {object} [options]
 * @param {string} [options.multipleFilesLabel]
 * @param {string} [options.inputSelector]
 * @param {string} [options.fileIconSelector]
 * @private
 */
export function initFileInput(
    elements,
    {
        multipleFilesLabel = '%s files selected',
        inputSelector = '[type="file"]',
        fileIconSelector = '.input--file__input__icon',
        fileLabelSelector: fileValueSelector = '.input--file__value',
    } = {},
) {
    elements.forEach(element => {
        // custom input styling
        const input = element.querySelector(inputSelector),
            observer = new MutationObserver(mutations => {
                mutations.forEach(({ attributeName, target }) => {
                    if (attributeName === 'disabled') {
                        element.classList.toggle('is-disabled', Boolean(target.disabled));

                        element.querySelectorAll(fileIconSelector).forEach(btn => {
                            if (target.disabled) {
                                btn.setAttribute('disabled', true);
                            } else {
                                btn.removeAttribute('disabled');
                            }
                        });
                    }
                });
            });

        input.addEventListener(
            'change',
            event => {
                let input = event.currentTarget,
                    files = input.files,
                    numFiles = files ? files.length : 1,
                    labelText =
                        numFiles > 1
                            ? multipleFilesLabel.replace(/(%s|:anz)/, numFiles) // also accept the old :anz for backwards compatibility
                            : input.value.replace(/\\/g, '/').replace(/.*\//, ''),
                    label = element.querySelector(fileValueSelector);

                if (label) {
                    label.innerHTML = labelText || label.dataset.placeholder;
                }

                if (numFiles) {
                    element.classList.add('has-value');
                } else {
                    element.classList.remove('has-value');
                }
            },
            eventListenerOptions({ passive: true }),
        );

        input.addEventListener('focus', () => {
            element.classList.add('has-focus');
        });

        input.addEventListener('blur', () => {
            element.classList.remove('has-focus');
        });

        observer.observe(input, { attributes: true });

        function openFileDialog(input) {
            input.click();
        }

        function clearFiles(input) {
            input.value = '';
            input.dispatchEvent(new Event('input'));
            input.dispatchEvent(new Event('change'));
        }

        element.querySelectorAll(fileIconSelector).forEach(button => {
            button.addEventListener(
                'click',
                () => {
                    let input = element.querySelector(inputSelector);

                    if (element.classList.contains('has-value')) {
                        clearFiles(input);
                    } else {
                        openFileDialog(input);
                    }
                },
                eventListenerOptions({ passive: true }),
            );
        });
    });
}
